import React, { useMemo } from 'react';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useUsersUIContext } from '../UsersUIContext';
import { FormattedMessage, injectIntl } from 'react-intl';

const prepareFilter = (queryParams, values) => {
  const { status, role, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  filter.status = status !== '' ? +status : undefined;
  // Filter by role
  filter.role = role !== '' ? role : undefined;
  // Filter by all fields
  if (searchText) {
    filter.name = searchText;
    filter.email = searchText;
    filter.mobileNo = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

function UsersFilter(props) {
  const { intl } = props;
  const roleOptionAdmin = intl.formatMessage({ id: 'USER.ROLE.ADMIN' });
  const roleOptionSVUser = intl.formatMessage({ id: 'USER.ROLE.SUPERVISOR' });
  const roleOptionUser = intl.formatMessage({ id: 'USER.ROLE.USER' });
  const roleOptionAll = intl.formatMessage({ id: 'USER.ROLE.ALL' });
  const statusOptionAll = intl.formatMessage({ id: 'USER.STATUS.ALL' });
  const statusOptionNew = intl.formatMessage({ id: 'USER.STATUS.NEW' });
  const statusOptionActive = intl.formatMessage({ id: 'USER.STATUS.ACTIVE' });
  const statusOptionInActive = intl.formatMessage({
    id: 'USER.STATUS.INCTIVE',
  });
  const statusOptionReActive = intl.formatMessage({
    id: 'USER.STATUS.REACTIVE',
  });
  const statusOptionBlocked = intl.formatMessage({ id: 'USER.STATUS.BLOCKED' });
  // Users UI Context
  const UsersUIContext = useUsersUIContext();
  const UsersUIProps = useMemo(() => {
    return {
      queryParams: UsersUIContext.queryParams,
      setQueryParams: UsersUIContext.setQueryParams,
    };
  }, [UsersUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(UsersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, UsersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      UsersUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          status: '', // values => All=""/Susspended=0/Active=1/Pending=2
          role: '', // values => All=""/Business=0/Individual=1
          searchText: '',
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className='form form-label-right'>
            <div className='form-group row'>
              <div className='col-lg-2'>
                <small className='form-text text-muted'>
                  <b>
                    <FormattedMessage id='USER.LABEL.STATUS' />
                  </b>
                </small>
                <select
                  className='form-control'
                  name='status'
                  // TODO: Change this code
                  onChange={(e) => {
                    setFieldValue('status', e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value=''>{statusOptionAll}</option>
                  <option value='0'>{statusOptionNew}</option>
                  <option value='1'>{statusOptionActive}</option>
                  <option value='2'>{statusOptionInActive}</option>
                  <option value='3'>{statusOptionReActive}</option>
                  <option value='5'>{statusOptionBlocked}</option>
                </select>
              </div>
              <div className='col-lg-2'>
                <small className='form-text text-muted'>
                  <b>
                    <FormattedMessage id='USER.LABEL.ROLE' />
                  </b>
                </small>
                <select
                  className='form-control'
                  name='role'
                  onChange={(e) => {
                    setFieldValue('role', e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.role}
                >
                  <option value=''>{roleOptionAll}</option>
                  <option value='Admin'>{roleOptionAdmin}</option>
                  <option value='Supervisor'>{roleOptionSVUser}</option>
                  <option value='User'>{roleOptionUser}</option>
                </select>
              </div>
              <div className='col-lg-2'>
                <small className='form-text text-muted'>
                  <b>
                    <FormattedMessage id='USER.LABEL.TEXT' />
                  </b>
                </small>
                <input
                  type='text'
                  className='form-control'
                  name='searchText'
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue('searchText', e.target.value);
                    handleSubmit();
                  }}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}

export default injectIntl(UsersFilter);
